export const firmTableColumns = [
  { title: 'Email', key: 'email', width: 16, keySort: 'email' },
  { title: 'Last Login', key: 'lastLogin', width: 16, keySort: 'last login' },
  { title: 'First Name', key: 'firstName', width: 16, keySort: 'first name' },
  { title: 'Last Name', key: 'lastName', width: 16, keySort: 'last name' },
  { title: 'Mobile Number', key: null, width: 16, keySort: 'mobile number' },
  { title: 'Roles', key: 'roles', width: 16, keySort: 'roles' },
  { title: ' ', key: null, width: 4, keySort: 'actionDropdown' }
];

export const tenantsTableColumns = [
  { title: 'Email', key: 'email', width: 14, keySort: 'email' },
  { title: 'Last Login', key: 'lastLogin', width: 14, keySort: 'last login' },
  { title: 'First Name', key: 'firstName', width: 14, keySort: 'first name' },
  { title: 'Last Name', key: 'lastName', width: 14, keySort: 'last name' },
  { title: 'Mobile Number', key: null, width: 14, keySort: 'mobile number' },
  { title: 'Roles', key: 'roles', width: 13, keySort: 'roles' },
  { title: 'Advisory Firm', key: 'tenant.name', width: 13, keySort: 'advisory firm' },
  { title: ' ', key: null, width: 4, keySort: 'actionDropdown' }
];
